import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { getDefaultUserMeTenant } from '@/features/auth/models'
import { USER_TYPE } from '@/libs/api/types'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/_system-master-settings'
)({
  beforeLoad: ({ context: { auth } }) => {
    const authUser = auth.user

    // ユーザはSub側かどうか
    const isSubSide = authUser.type === USER_TYPE.PARTNER

    if (isSubSide) {
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}`
      })
    }
  },
  component: () => <Outlet />
})
